<template>
  <div>
  <el-row class="panel-group" :gutter="40">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class='card-panel' @click="handleSetLineChartData('newVisitis')">
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon name="shoppingCard" class="card-panel-icon" width="56px" height="56px"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">昨日</div>
          <div v-if="yestoday == null" class="card-panel-num" >暂无统计数据</div>
          <count-to v-if="yestoday != null" prefix="共" suffix="单" class="card-panel-num" :startVal="0" :endVal="yestoday.realCount" :duration="2600"></count-to>
          <count-to v-if="yestoday != null" prefix="收入" suffix="元" class="card-panel-num" :startVal="0" :endVal="yestoday.realAmount/100" :duration="2600"></count-to>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('messages')">
        <div class="card-panel-icon-wrapper icon-message">
          <svg-icon name="shoppingCard" class="card-panel-icon" width="56px" height="56px"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">今日</div>
          <div v-if="today == null" class="card-panel-num" >暂无订单</div>
          <count-to v-if="today != null" prefix="共" suffix="单" class="card-panel-num" :startVal="0" :endVal="today.realCount" :duration="2600"></count-to>
          <count-to v-if="today != null" prefix="收入" suffix="元" class="card-panel-num" :startVal="0" :endVal="today.realAmount/100" :duration="2600"></count-to>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon name="money" class="card-panel-icon" width="56px" height="56px"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">上周</div>
          <div v-if="lastWeek == null" class="card-panel-num" >暂无统计数据</div>
          <count-to v-if="lastWeek != null" prefix="共" suffix="单" class="card-panel-num" :startVal="0" :endVal="lastWeek.realCount" :duration="2600"></count-to>
          <count-to v-if="lastWeek != null" prefix="收入" suffix="元" class="card-panel-num" :startVal="0" :endVal="lastWeek.realAmount/100" :duration="2600"></count-to>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-shoppingCard">
          <svg-icon name="money" class="card-panel-icon" width="56px" height="56px"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">本周</div>
          <div v-if="nowWeek == null" class="card-panel-num" >暂无订单</div>
          <count-to v-if="nowWeek != null" prefix="共" suffix="单" class="card-panel-num" :startVal="0" :endVal="nowWeek.realCount" :duration="2600"></count-to>
          <count-to v-if="nowWeek != null" prefix="收入" suffix="元" class="card-panel-num" :startVal="0" :endVal="nowWeek.realAmount/100" :duration="2600"></count-to>
        </div>
      </div>
    </el-col>
  </el-row>



  <el-row class="panel-group" :gutter="40">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class='card-panel'>
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon name="shoppingCard" class="card-panel-icon" width="56px" height="56px"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">今日待确认</div>
          <div v-if="today == null" class="card-panel-num" >暂无统计数据</div>
          <count-to v-if="today != null" prefix="共" suffix="单" class="card-panel-num" :startVal="0" :endVal="today.unSureCount" :duration="2600"></count-to>
          <count-to v-if="today != null" prefix="收入" suffix="元" class="card-panel-num" :startVal="0" :endVal="today.unSureAmount/100" :duration="2600"></count-to>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message">
          <svg-icon name="shoppingCard" class="card-panel-icon" width="56px" height="56px"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">今日已确认</div>
          <div v-if="today == null" class="card-panel-num" >暂无统计数据</div>
          <count-to v-if="today != null" prefix="共" suffix="单" class="card-panel-num" :startVal="0" :endVal="today.sureCount" :duration="2600"></count-to>
          <count-to v-if="today != null" prefix="收入" suffix="元" class="card-panel-num" :startVal="0" :endVal="today.sureAmount/100" :duration="2600"></count-to>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon name="shoppingCard" class="card-panel-icon" width="56px" height="56px"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">今日待支付</div>
          <div v-if="today == null" class="card-panel-num" >暂无统计数据</div>
          <count-to v-if="today != null" prefix="共" suffix="单" class="card-panel-num" :startVal="0" :endVal="today.unPayCount" :duration="2600"></count-to>
          <count-to v-if="today != null" prefix="收入" suffix="元" class="card-panel-num" :startVal="0" :endVal="today.unPayAmount/100" :duration="2600"></count-to>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-shoppingCard">
          <svg-icon name="shoppingCard" class="card-panel-icon" width="56px" height="56px"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">今日已支付</div>
          <div v-if="today == null" class="card-panel-num" >暂无统计数据</div>
          <count-to v-if="today != null" prefix="共" suffix="单" class="card-panel-num" :startVal="0" :endVal="today.payCount" :duration="2600"></count-to>
          <count-to v-if="today != null" prefix="收入" suffix="元" class="card-panel-num" :startVal="0" :endVal="today.payAmount/100" :duration="2600"></count-to>
        </div>
      </div>
    </el-col>
  </el-row>
  <el-row class="panel-group" :gutter="40">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class='card-panel'>
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon name="shoppingCard" class="card-panel-icon" width="56px" height="56px"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">今日已取消</div>
          <div v-if="today == null" class="card-panel-num" >暂无统计数据</div>
          <count-to v-if="today != null" prefix="共" suffix="单" class="card-panel-num" :startVal="0" :endVal="today.cancelCount" :duration="2600"></count-to>
          <count-to v-if="today != null" prefix="收入" suffix="元" class="card-panel-num" :startVal="0" :endVal="today.cancelAmount/100" :duration="2600"></count-to>
        </div>
      </div>
    </el-col>
  </el-row>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'
import '@/icons';
export default {
  components: {
      CountTo
  },
  data(){
      return {
          today:null,
          yestoday:null,
          lastWeek:null,
          nowWeek:null,
      }
  },
  mounted(){
      this.initData();
  },
  methods: {
    handleSetLineChartData(type) {
  },
  initData(){
      var that = this;
      that.$api.get('/store/home/orders/stat',null, response => {
          if (response.status >= 200 && response.status < 300) {
              var res = response.data;
              if (res.code == 0) {
                  that.today = res.data.todayStats;
                  that.yestoday = res.data.yestodayStats;
                  that.lastWeek = res.data.lastWeekStats;
                  that.nowWeek = res.data.nowWeekStats;
                  console.log(response);
              }else{
                  this.$message({
                      message: res.msg,
                      type: 'warning'
                  });
              }
          } else {
              this.$message({
                  message: "服务器维护中",
                  type: 'error'
              });
          }
      });
  },
  }
}
</script>

<style lang="less">
.panel-group {
  margin-top: 18px;
  .card-panel-col{
    margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
         background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/store/components/PanelGroup.vue